const LIMIT = 50
const SKIP = 0
const MESSAGE_STATUS = {
  LOADING: 'LOADING',
  LOADED: 'LOADED'
}

const FILETYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/webp',
  'image/svg+xml',
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'audio/mp3',
  'audio/mpeg',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'
]

const TOOLS = {
  BOLD: 'BOLD',
  ITALIC: 'ITALIC',
  STRIKE: 'STRIKE',
  LINK: {
    VIEWER: 'LINK_VIEWER',
    CREATOR: 'LINK_CREATOR'
  },
  LIST: {
    BULLET: 'LIST_BULLET',
    ORDERED: 'LIST_ORDERED'
  },
  TODO: 'TODO',
  MATH: 'MATH',
  EMOJI: 'EMOJI'
}

const MODES = {
  TEXT: 'TEXT',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  FILE: 'FILE',
  SKETCH: 'SKETCH',
  TEX: 'TEX',
  CODE: 'CODE'
}

/**
 * Source: {@link http://www.regexguru.com/2008/11/detecting-urls-in-a-block-of-text/}
 * Tests: {@link https://regexr.com/5i7lf}
 */
const HyperLinkRegExp =
  /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/gim

export default {
  LIMIT,
  SKIP,
  MESSAGE_STATUS,
  TOOLS,
  MODES,
  FILETYPES,
  HyperLinkRegExp
}
